import React, { useEffect } from 'react';
import './index.less';

interface IModalProps {
	title: string;
	onClose: () => void;
	text?: string;
}

export const Modal: React.FC<IModalProps> = ({ title, text, onClose, children }) => {
	useEffect(() => {
		function handleEscapeKey(e: KeyboardEvent) {
			if (e.keyCode === 27) {
				onClose();
			}
		}
		document.addEventListener('keydown', handleEscapeKey);
		return () => document.removeEventListener('keydown', handleEscapeKey);
	});

	const handleExitModal = (event: React.SyntheticEvent<HTMLElement>) => {
		if ((event.target as HTMLElement).className === 'background') {
			onClose();
		}
	};

	return (
		<div className="app-modal">
			{/* The <div> element has child elements that allow keyboard/mouse interaction. Key events are handled by handleEscapeKey useEffect */}
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
			<div className="background" onClick={handleExitModal}>
				<div className="modal-content">
					<button className="modal-content-close" onClick={onClose} />
					<div className="modal-content-title">{title}</div>
					<div className="modal-content-line" />
					{text ? <h3 className="modal-content-text">{text}</h3> : null}
					<div className="modal-content-children">{children}</div>
				</div>
			</div>
		</div>
	);
};
